module.exports = __webpack_public_path__ + "static/catalog-fa-footer-4f3c4137bb269bc968cd383d5e39e242.jpeg";